import {extendConfig} from './extend-config';

export const config = extendConfig({
  datadog: {
    environment: `dev`,
    enabled: true,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
  },
  groundcover: {
    sessionSampleRate: 100,
  },
  nextauth: {
    invalidateWhenIdpSessionExpired: {},
  },
});
